export default _ => (dispatch, getState) =>
  dispatch({type: 'toggle_loading_estates'})



/** WEBPACK FOOTER **
 ** ./app/actions/toggleLoadingEstates.jsx
 **/